// utils
import axios from "src/utils/axios";

// ----------------------------------------------------------------------

const API_ENDPOINTS = {
    getBalance: "/transaction/wallet/info",
    //
    getCard: "/transaction/bank_card/info",
    modifyCard: "/transaction/bank_card/update",
    //
    editRechargeAmount: "/transaction/wallet/recharge_amount/update",
    tryRecharge: "/transaction/wallet/try_recharge"
};

// ----------------------------------------------------------------------

const getBalance = () => axios.get(`${ API_ENDPOINTS.getBalance }`);

const getCard = () => axios.get(`${ API_ENDPOINTS.getCard }`);

const modifyCard = (request) => axios.post(`${ API_ENDPOINTS.modifyCard }`, { ...request });

const editRechargeAmount = (request) => axios.post(`${ API_ENDPOINTS.editRechargeAmount }`, { ...request });

const tryRecharge = () => axios.post(`${ API_ENDPOINTS.tryRecharge }`);

// ----------------------------------------------------------------------

export {
    getBalance as getBalanceAPI,
    //
    getCard as getCardAPI,
    modifyCard as modifyCardAPI,
    //
    editRechargeAmount as editRechargeAmountAPI,
    tryRecharge as tryRechargeAPI
};
